<script lang="ts" setup>
const props = defineProps<{
  eyebrow?: string;
  title?: string;
  text?: string;
}>();

const spineTitleState = useState("spineTitle").value;
const propAbstract = inject<string | undefined>("abstract");
const headerTitle = props.title ?? spineTitleState;
</script>

<template>
  <div class="col-span-full content-grid pt-6 lg:pt-22">
    <span
      class="text-lg lg:text-2xl font-sans font-bold mb-4 uppercase"
      v-if="eyebrow"
      >{{ eyebrow }}</span
    >
    <h1 class="text-5xl lg:text-8xl mb-22">{{ headerTitle }}</h1>
  </div>
  <div v-if="propAbstract || text" class="inner-content-grid">
    <template v-if="text">
      <div class="text-xl lg:text-3xl mb-4" v-html="text"></div>
    </template>
    <p v-else class="text-xl lg:text-3xl mb-4">{{ propAbstract }}</p>
  </div>
</template>
